module.exports = __webpack_public_path__ + "img/important.41a512a5.png";